<template>
  <div class="data-show">
    <label
      :style="{
        minWidth: minWidth ? `${minWidth}px` : null,
        maxWidth: maxWidth ? `${maxWidth}px` : null,
      }"
    >{{label}}</label>
    <div class="data-show-content"><slot name="default"></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    // 标签
    label: {
      type: String,
      required: true,
    },
    // Label 最小宽度
    minWidth: {
      type: Number,
      default: 0,
    },
    // Label 最大宽度
    maxWidth: {
      type: Number,
      default: 0,
    },
  },

};
</script>

<style lang="scss" scoped>
.data-show {
  padding: 8px 0;
  line-height: 1.5;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  color: #4d4f51;
  justify-content: center;
  align-items: flex-start;
  > label {
    display: inline-block;
    opacity: 0.7;
    margin-right: 8px;
    white-space: nowrap;
  }

  .data-show-content {
    flex: 1;
    word-break: break-all;
    min-width: 1px;
    line-height: 18px;
  }
}
</style>
